var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order_id)?_c('div',[_c('router-link',{attrs:{"to":("/repairs/order/" + _vm.order_id + "?path=''")}},[_vm._v("перейти в заявку")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }